/*
 * Sawaaro cart page (sections/sawaaro-main-cart.liquid)
 *
 * - Quantity, remove, save for later, size swap: Shopify AJAX Cart API
 * - Coupon codes: Storefront API (window.SAWAARO_STOREFRONT, public token),
 *   falling back to /cart/update.js
 * - Unticked items: kept in localStorage ("held") and taken out of the Shopify
 *   cart, so what Shopify sees is always exactly the ticked items.
 * - After every change the section is re-rendered with the Section Rendering API.
 */
(function () {
  'use strict';
  if (window.__sawaaroCartInit) return;
  window.__sawaaroCartInit = true;

  var HELD_KEY = 'sawaaro_cart_held';
  var ZIP_KEY = 'sawaaro_pincode';
  var WISH_KEY = 'sawaaro_wishlist';

  /* ---------- small helpers ---------- */
  function root() { return document.getElementById('SawaaroCart'); }
  function $(sel, el) { return (el || root() || document).querySelector(sel); }

  function lsGet(key, fallback) {
    try { var v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; }
  }
  function lsSet(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* private mode */ }
  }
  function getHeld() { var h = lsGet(HELD_KEY, []); return Array.isArray(h) ? h : []; }
  function setHeld(list) { lsSet(HELD_KEY, list); }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
  function money(cents) {
    try {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: currency, maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return '₹' + Math.round(cents / 100); }
  }

  function showMsg(text, isError) {
    var el = $('[data-swc-msg]');
    if (!el) return;
    el.textContent = text;
    el.classList.toggle('is-error', !!isError);
    el.hidden = false;
    clearTimeout(showMsg.t);
    showMsg.t = setTimeout(function () { el.hidden = true; }, 5000);
  }

  function setBusy(on) {
    var r = root();
    if (r) r.classList.toggle('is-busy', on);
  }

  function ajax(path, body) {
    return fetch(path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (json) {
        if (!res.ok) throw new Error(json.description || json.message || 'Something went wrong. Please try again.');
        return json;
      });
    });
  }
  var cartGet = function () { return ajax('/cart.js'); };
  var cartChange = function (key, qty) { return ajax('/cart/change.js', { id: key, quantity: qty }); };
  var cartAdd = function (items) { return ajax('/cart/add.js', { items: items }); };

  /* ---------- re-render ---------- */
  function refresh() {
    var r = root();
    if (!r) return Promise.resolve();
    var id = r.getAttribute('data-section-id');
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id))
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('SawaaroCart');
        if (fresh) r.replaceWith(fresh);
        hydrate();
      });
  }

  function run(task, okMsg) {
    setBusy(true);
    return Promise.resolve()
      .then(task)
      .then(refresh)
      .then(function () { if (okMsg) showMsg(okMsg); })
      .catch(function (err) { return refresh().then(function () { showMsg(err.message, true); }); })
      .then(function () { setBusy(false); });
  }

  /* ---------- after each render ---------- */
  function hydrate() {
    var r = root();
    if (!r) return;
    renderHeld();
    updateSelection();
    updateBadge();
    renderDelivery();
    if (!window.__swcAddrSynced) {
      window.__swcAddrSynced = true;
      applyAddress(currentAddress(), false);
    }
  }

  function updateBadge() {
    var r = root();
    var n = parseInt(r.getAttribute('data-item-count'), 10) || 0;
    document.querySelectorAll('[data-sw-cart-count]').forEach(function (b) {
      b.textContent = n;
      b.style.display = n === 0 ? 'none' : '';
    });
  }

  function renderHeld() {
    var list = $('[data-swc-held]');
    if (!list) return;
    list.innerHTML = getHeld().map(function (h, i) {
      return '' +
        '<li class="swc__item is-held" data-held-index="' + i + '">' +
          '<button type="button" class="swc__cb" data-swc-tick aria-label="Add ' + esc(h.title) + ' back to this order">' +
            '<span class="swc__cb-box" data-state="none"></span></button>' +
          '<a href="' + esc(h.url) + '" class="swc__img" tabindex="-1" aria-hidden="true">' +
            (h.image ? '<img src="' + esc(h.image) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="swc__info">' +
            '<a href="' + esc(h.url) + '" class="swc__name"><span class="swc__name-full">' + esc(h.title) + '</span><span class="swc__name-short">' + esc(h.title.length > 50 ? h.title.slice(0, 47) + '...' : h.title) + '</span></a>' +
            '<div class="swc__opts">' +
              (h.size ? '<span class="swc__opt">Size: ' + esc(h.size) + '</span>' : '') +
              '<span class="swc__opt">Qty ' + esc(h.quantity) + '</span></div>' +
            '<div class="swc__price"><b>' + money(h.price * h.quantity) + '</b>' +
              (h.mrp > h.price ? '<s>' + money(h.mrp * h.quantity) + '</s>' : '') + '</div>' +
            '<p class="swc__held-note">Not in this order. Stays in your cart for next time.</p>' +
            '<div class="swc__actions"><button type="button" class="swc__link-btn" data-swc-held-remove>Remove</button></div>' +
          '</div></li>';
    }).join('');
  }

  function updateSelection() {
    var r = root();
    var sel = parseInt(r.getAttribute('data-line-count'), 10) || 0;
    var held = getHeld().length;
    var total = sel + held;

    var count = $('[data-swc-selcount]');
    if (count) count.textContent = sel + '/' + total + ' item' + (total === 1 ? '' : 's') + ' selected';

    var master = $('[data-swc-master]');
    if (master) master.setAttribute('data-state', held === 0 ? 'all' : sel === 0 ? 'none' : 'some');
    var masterBtn = $('[data-swc-select-all]');
    if (masterBtn) masterBtn.setAttribute('aria-label', held === 0 ? 'Leave all items out of this order' : 'Select all items');

    // Empty cart but held items exist: keep the cart layout visible.
    var empty = $('[data-swc-empty]');
    var grid = $('[data-swc-grid]');
    if (empty && grid) {
      empty.hidden = total > 0;
      grid.hidden = total === 0;
    }
    var deliver = $('[data-swc-deliver]');
    if (deliver) deliver.hidden = total === 0;
  }

  /* ---------- delivery estimate ---------- */
  var METRO = ['11', '40', '56', '60', '70', '50', '41', '38'];
  function zoneFor(zip) {
    var p2 = zip.slice(0, 2), p3 = zip.slice(0, 3);
    if (['78', '79', '18', '19'].indexOf(p2) !== -1 || p3 === '744' || p3 === '682') return 'remote';
    if (METRO.indexOf(p2) !== -1) return 'metro';
    return 'other';
  }
  function etaText(zip) {
    var r = root();
    var days = parseInt(r.getAttribute('data-days-' + zoneFor(zip)), 10) || 5;
    var d = new Date();
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) days--; // no Sunday deliveries
    }
    return 'Estimated delivery by ' + d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
  }
  /* ---------- delivery address ---------- */
  var ADDR_KEY = 'sawaaro_address';
  var ADDR_APPLIED_KEY = 'sawaaro_address_applied';
  var STATES = [['AN','Andaman and Nicobar Islands'],['AP','Andhra Pradesh'],['AR','Arunachal Pradesh'],['AS','Assam'],['BR','Bihar'],['CH','Chandigarh'],['CG','Chhattisgarh'],['DN','Dadra and Nagar Haveli'],['DD','Daman and Diu'],['DL','Delhi'],['GA','Goa'],['GJ','Gujarat'],['HR','Haryana'],['HP','Himachal Pradesh'],['JK','Jammu and Kashmir'],['JH','Jharkhand'],['KA','Karnataka'],['KL','Kerala'],['LA','Ladakh'],['LD','Lakshadweep'],['MP','Madhya Pradesh'],['MH','Maharashtra'],['MN','Manipur'],['ML','Meghalaya'],['MZ','Mizoram'],['NL','Nagaland'],['OR','Odisha'],['PY','Puducherry'],['PB','Punjab'],['RJ','Rajasthan'],['SK','Sikkim'],['TN','Tamil Nadu'],['TS','Telangana'],['TR','Tripura'],['UP','Uttar Pradesh'],['UK','Uttarakhand'],['WB','West Bengal']];

  function currentAddress() {
    var saved = lsGet(ADDR_KEY, null);
    if (saved && saved.zip) return saved;
    var r = root();
    var d = r && r.getAttribute('data-default-address');
    if (d) { try { return JSON.parse(d); } catch (e) { /* ignore */ } }
    var zip = lsGet(ZIP_KEY, '');
    return zip ? { zip: String(zip) } : null;
  }

  function renderDelivery() {
    var box = $('[data-swc-deliver]');
    if (!box) return;
    var a = currentAddress();
    var to = $('[data-swc-deliver-to]'), line = $('[data-swc-addr-line]'), eta = $('[data-swc-eta]'), btn = $('[data-swc-addr-open]');
    if (a && /^\d{6}$/.test(String(a.zip || ''))) {
      to.innerHTML = '<span class="swc__muted">Deliver to </span><b>' + esc(a.name ? a.name + ', ' + a.zip : a.zip) + '</b>';
      var parts = [a.address1, a.address2, a.city].filter(Boolean);
      line.textContent = parts.join(', ');
      line.hidden = !parts.length;
      eta.textContent = etaText(String(a.zip));
      eta.hidden = false;
      btn.textContent = a.address1 ? 'Change' : 'Add address';
    } else {
      to.innerHTML = '<span class="swc__muted">Add a delivery address to see your delivery date</span>';
      line.hidden = true;
      eta.hidden = true;
      btn.textContent = 'Add address';
    }
  }

  function openSheet() {
    var sheet = $('[data-swc-sheet]');
    if (!sheet) return;
    var state = $('#SwcAState');
    if (state && state.options.length < 2) {
      STATES.forEach(function (st) { state.add(new Option(st[1], st[0])); });
    }
    var a = currentAddress() || {};
    var f = $('[data-swc-addr-form]');
    f.elements.name.value = a.name || '';
    f.elements.phone.value = String(a.phone || '').replace(/\D/g, '').slice(-10);
    f.elements.zip.value = a.zip || '';
    f.elements.address1.value = a.address1 || '';
    f.elements.address2.value = a.address2 || '';
    f.elements.city.value = a.city || '';
    f.elements.provinceCode.value = a.provinceCode || '';
    $('[data-swc-addr-err]').hidden = true;
    sheet.hidden = false;
    document.documentElement.classList.add('swc-lock');
    var first = sheet.querySelector('.swc-addr-card, input');
    if (first) first.focus();
  }
  function closeSheet() {
    var sheet = $('[data-swc-sheet]');
    if (sheet) sheet.hidden = true;
    document.documentElement.classList.remove('swc-lock');
    var btn = $('[data-swc-addr-open]');
    if (btn) btn.focus();
  }

  function lookupPincode(zip) {
    // Fills city and state from India Post. Optional: if it fails, the shopper types them.
    fetch('https://api.postalpincode.in/pincode/' + zip)
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var po = j && j[0] && j[0].PostOffice && j[0].PostOffice[0];
        if (!po) return;
        var f = $('[data-swc-addr-form]');
        if (!f) return;
        if (!f.elements.city.value) f.elements.city.value = po.District || '';
        var name = String(po.State || '').toLowerCase().replace(/&/g, 'and').replace(/\s+/g, ' ').trim();
        STATES.forEach(function (st) { if (st[1].toLowerCase() === name) f.elements.provinceCode.value = st[0]; });
      })
      .catch(function () { /* ignore */ });
  }

  function saveAddress(a) {
    lsSet(ADDR_KEY, a);
    lsSet(ZIP_KEY, a.zip);
    closeSheet();
    renderDelivery();
    applyAddress(a, true);
  }

  var ADDRESS_MUTATION =
    'mutation($cartId: ID!, $addresses: [CartSelectableAddressInput!]!) {' +
    '  cartDeliveryAddressesReplace(cartId: $cartId, addresses: $addresses) {' +
    '    userErrors { message }' +
    '  }' +
    '}';

  // Puts the address on the Shopify cart so checkout opens with it filled in.
  function applyAddress(a, announce) {
    if (!a || !a.address1 || !a.zip) return Promise.resolve();
    return cartGet().then(function (cart) {
      if (!cart.item_count) return;
      var sig = cart.token + '|' + [a.name, a.phone, a.address1, a.address2, a.city, a.provinceCode, a.zip].join('|');
      if (!announce && lsGet(ADDR_APPLIED_KEY, '') === sig) return;
      var name = String(a.name || '').trim().split(/\s+/);
      var phone = String(a.phone || '').replace(/\D/g, '').slice(-10);
      var addr = {
        firstName: name.shift() || '',
        lastName: name.join(' ') || '.',
        address1: a.address1,
        address2: a.address2 || '',
        city: a.city,
        provinceCode: a.provinceCode || null,
        zip: String(a.zip),
        countryCode: 'IN'
      };
      if (phone.length === 10) addr.phone = '+91' + phone;
      return storefront(ADDRESS_MUTATION, {
        cartId: 'gid://shopify/Cart/' + cart.token,
        addresses: [{ selected: true, address: { deliveryAddress: addr } }]
      }).then(function (json) {
        var out = json && json.data && json.data.cartDeliveryAddressesReplace;
        if (!out || (out.userErrors && out.userErrors.length)) throw new Error('address');
        lsSet(ADDR_APPLIED_KEY, sig);
        if (announce) showMsg('Address saved. Checkout will open with it filled in.');
      });
    }).catch(function () {
      if (announce) showMsg('Address saved here. You may be asked to confirm it at checkout.');
    });
  }

  /* ---------- coupons ---------- */
  function storefront(query, variables) {
    var cfg = window.SAWAARO_STOREFRONT;
    if (!cfg || !cfg.token) return Promise.reject(new Error('no-storefront'));
    return fetch(cfg.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': cfg.token },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (res) { return res.json(); });
  }

  var DISCOUNT_MUTATION =
    'mutation($cartId: ID!, $codes: [String!]) {' +
    '  cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $codes) {' +
    '    cart { discountCodes { code applicable } }' +
    '    userErrors { message }' +
    '  }' +
    '}';

  function setCodes(codes) {
    return cartGet().then(function (cart) {
      var cartId = 'gid://shopify/Cart/' + cart.token;
      return storefront(DISCOUNT_MUTATION, { cartId: cartId, codes: codes })
        .then(function (json) {
          var out = json && json.data && json.data.cartDiscountCodesUpdate;
          if (!out) throw new Error('no-storefront');
          if (out.userErrors && out.userErrors.length) throw new Error(out.userErrors[0].message);
          return out.cart.discountCodes || [];
        })
        .catch(function (err) {
          if (err.message !== 'no-storefront' && !/fetch|network/i.test(err.message)) throw err;
          // Fallback: AJAX Cart API
          return ajax('/cart/update.js', { discount: codes.join(',') }).then(function (c) {
            return (c.discount_codes || []).map(function (d) { return { code: d.code, applicable: d.applicable }; });
          });
        });
    });
  }

  function applyCoupon(code) {
    code = String(code || '').trim().toUpperCase();
    var err = $('[data-swc-coupon-err]');
    if (err) err.hidden = true;
    if (!code) { showCouponError('Type a coupon code first.'); return; }

    setBusy(true);
    setCodes([code])
      .then(function (codes) {
        var hit = codes.filter(function (c) { return c.code.toUpperCase() === code; })[0];
        if (!hit || !hit.applicable) {
          return setCodes([]).then(function () {
            return refresh().then(function () {
              showCouponError(code + " can't be used on this cart. Check the offer conditions or try another code.");
            });
          });
        }
        return refresh().then(function () { showMsg(code + ' applied.'); });
      })
      .catch(function (e) { return refresh().then(function () { showCouponError(e.message); }); })
      .then(function () { setBusy(false); });
  }
  function showCouponError(text) {
    var err = $('[data-swc-coupon-err]');
    if (!err) return;
    err.textContent = text;
    err.hidden = false;
  }

  /* ---------- wishlist (same storage as sawaaro-wishlist.js) ---------- */
  function addToWishlist(productId) {
    productId = String(productId);
    if (window.SawaaroWishlist && window.SawaaroWishlist.add) {
      window.SawaaroWishlist.add(productId);
    } else {
      var list = lsGet(WISH_KEY, []).map(String);
      if (list.indexOf(productId) === -1) list.push(productId);
      lsSet(WISH_KEY, list);
    }
    document.dispatchEvent(new CustomEvent('sawaaro:wishlist:updated', {
      detail: { productId: productId, wishlist: lsGet(WISH_KEY, []).map(String) }
    }));
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var r = root();
    if (!r || !r.contains(e.target) || r.classList.contains('is-busy')) return;
    var t = e.target;
    var line = t.closest('[data-swc-line]');
    var key = line && line.getAttribute('data-key');

    var step = t.closest('[data-swc-qty-step]');
    if (step && key) {
      var n = parseInt(line.querySelector('.swc__qty-n').textContent, 10) || 1;
      var next = Math.max(1, n + parseInt(step.getAttribute('data-swc-qty-step'), 10));
      run(function () { return cartChange(key, next); });
      return;
    }

    if (t.closest('[data-swc-remove]') && key) {
      run(function () { return cartChange(key, 0); }, 'Item removed.');
      return;
    }

    var save = t.closest('[data-swc-save]');
    if (save && key) {
      addToWishlist(save.getAttribute('data-product-id'));
      run(function () { return cartChange(key, 0); });
      return;
    }

    if (t.closest('[data-swc-untick]') && key) {
      var data = JSON.parse(line.getAttribute('data-held'));
      var held = getHeld();
      var same = held.filter(function (h) { return h.variant_id === data.variant_id; })[0];
      if (same) same.quantity += data.quantity; else held.push(data);
      setHeld(held);
      run(function () { return cartChange(key, 0); });
      return;
    }

    var heldItem = t.closest('[data-held-index]');
    if (heldItem) {
      var idx = parseInt(heldItem.getAttribute('data-held-index'), 10);
      var list = getHeld();
      var h = list[idx];
      if (!h) return;
      if (t.closest('[data-swc-held-remove]')) {
        list.splice(idx, 1);
        setHeld(list);
        hydrate();
        return;
      }
      if (t.closest('[data-swc-tick]')) {
        run(function () {
          return cartAdd([{ id: h.variant_id, quantity: h.quantity }]).then(function () {
            var now = getHeld();
            now.splice(idx, 1);
            setHeld(now);
          });
        });
      }
      return;
    }

    if (t.closest('[data-swc-select-all]')) {
      var all = getHeld();
      if (all.length) {
        // Tick everything back in. Items that can't be added (sold out) stay held.
        run(function () {
          var left = [];
          return all.reduce(function (p, item) {
            return p.then(function () {
              return cartAdd([{ id: item.variant_id, quantity: item.quantity }]).catch(function () { left.push(item); });
            });
          }, Promise.resolve()).then(function () {
            setHeld(left);
            if (left.length) throw new Error(left.length + ' item' + (left.length > 1 ? 's are' : ' is') + ' sold out and could not be added back.');
          });
        });
      } else {
        // Leave everything out of this order.
        var lines = Array.prototype.slice.call(r.querySelectorAll('[data-swc-line]'));
        if (!lines.length) return;
        var add = lines.map(function (l) { return JSON.parse(l.getAttribute('data-held')); });
        var updates = {};
        lines.forEach(function (l) { updates[l.getAttribute('data-key')] = 0; });
        setHeld(getHeld().concat(add));
        run(function () { return ajax('/cart/update.js', { updates: updates }); });
      }
      return;
    }

    var offer = t.closest('[data-swc-offer]');
    if (offer) {
      var input = $('#SwcCoupon');
      if (input) input.value = offer.getAttribute('data-swc-offer');
      applyCoupon(offer.getAttribute('data-swc-offer'));
      return;
    }

    if (t.closest('[data-swc-coupon-remove]')) {
      run(function () { return setCodes([]); }, 'Coupon removed.');
      return;
    }

    if (t.closest('[data-swc-addr-open]')) { openSheet(); return; }
    if (t.closest('[data-swc-sheet-close]')) { closeSheet(); return; }

    var pick = t.closest('[data-swc-addr-pick]');
    if (pick) {
      try { saveAddress(JSON.parse(pick.getAttribute('data-swc-addr-pick'))); } catch (err) { /* ignore */ }
    }
  });

  document.addEventListener('keydown', function (e) {
    var sheet = $('[data-swc-sheet]');
    if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet();
  });

  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'SwcAZip') {
      var z = e.target.value.replace(/\D/g, '');
      e.target.value = z;
      if (z.length === 6) lookupPincode(z);
    }
    if (e.target && e.target.id === 'SwcAPhone') e.target.value = e.target.value.replace(/\D/g, '');
  });

  document.addEventListener('submit', function (e) {
    var r = root();
    if (!r || !r.contains(e.target)) return;

    if (e.target.matches('[data-swc-coupon-form]')) {
      e.preventDefault();
      applyCoupon($('#SwcCoupon').value);
      return;
    }

    if (e.target.matches('[data-swc-addr-form]')) {
      e.preventDefault();
      var f = e.target.elements;
      var err = $('[data-swc-addr-err]');
      var a = {
        name: f.name.value.trim(),
        phone: f.phone.value.replace(/\D/g, ''),
        zip: f.zip.value.replace(/\D/g, ''),
        address1: f.address1.value.trim(),
        address2: [f.address2.value.trim(), f.landmark.value.trim() ? 'Near ' + f.landmark.value.trim() : ''].filter(Boolean).join(', '),
        city: f.city.value.trim(),
        provinceCode: f.provinceCode.value
      };
      var problem =
        !a.name ? 'Enter your full name.' :
        a.phone.length !== 10 ? 'Enter a 10-digit mobile number.' :
        a.zip.length !== 6 ? 'Enter a 6-digit pincode.' :
        !a.address1 ? 'Enter your flat, house number or building.' :
        !f.address2.value.trim() ? 'Enter your area, street or locality.' :
        !a.city ? 'Enter your city.' :
        !a.provinceCode ? 'Select your state.' : '';
      if (problem) { err.textContent = problem; err.hidden = false; return; }
      saveAddress(a);
    }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-swc-size]');
    if (!sel) return;
    var line = sel.closest('[data-swc-line]');
    var key = line.getAttribute('data-key');
    var qty = parseInt(line.querySelector('.swc__qty-n').textContent, 10) || 1;
    var newId = parseInt(sel.value, 10);
    // Add the new size first, then drop the old line, so nothing is lost if the new size fails.
    run(function () {
      return cartAdd([{ id: newId, quantity: qty }]).then(function () { return cartChange(key, 0); });
    }, 'Size updated.');
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate);
  else hydrate();
})();
